import React, { useEffect, useState } from "react";
import  OrgLogo from "../../Assets/Main/Utils/org-logo.png";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { logout } from "../../Redux/Actions/authActions";
import "./sidebar.css"

const SideBar = () => {
  const { admin, payment_executive } = useSelector((state) => state.admin);

  const [loggedUser, setLoggedUser] = useState({});

  useEffect(() => {
    if (admin?.data) {
      setLoggedUser(admin);
    } else {
      setLoggedUser(payment_executive);
    }
  }, [admin, payment_executive]);

  const location = useLocation();

  const handleClick = (name_with_underscore) => {
  const role = loggedUser?.data?.role;

  if (role === "payment_executive" && name_with_underscore === "bookings") {
    navigate(`/bookings/payment_exec/${loggedUser?.data?._id}`);
  } else {
    navigate(`/${name_with_underscore}`);
  }
};


  // const dispatch = useDispatch();
  const navigate = useNavigate();

  // const logoutFunction = (event) => {
  //   event.preventDefault();
  //   dispatch(logout());
  //   navigate("/");
  // };
  return (
    <div className="sidebar border-24">
      <div className="sidebar-content">
        <div className="sidebar-logo flex-container flex-center" style={{marginRight: "3px"}}>
          <Link to={"/dashboard"}>
          <img style={{width: "160px", height: "62px"}} src={OrgLogo} alt="logo" />
          </Link>
        </div>
        <div className="sidebar-menu">
          {loggedUser?.data?.access ? (
            loggedUser.data.access.map((item, index) => {
              const isActive =
                location.pathname === `/${item.name_with_underscore}`;
                if(item.name==="cab Settings" || item.name==="create coupons") return;
                else if(item.name==="deals")
                  return(
                <div
                  key={index}
                  onClick={()=>navigate("/dealsAndOffers")}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                  }}
                  className={`sidebar-menu-item ${isActive ? "active" : ""}`}
                >
                  <div>
                    {
                      <img
                        style={{ width: "22px", height: "22px" }}
                        src={item.image || ""}
                        alt={item.name || ""}
                      />
                    }
                  </div>

                  <div>
                    {"Deals & Offers"}
                  </div>
                </div>
                )
              return (
                <div
                  key={index}
                  onClick={() => handleClick(item.name_with_underscore)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                  }}
                  className={`sidebar-menu-item ${isActive ? "active" : ""}`}
                >
                  <div>
                    {
                      <img
                        style={{ width: "22px", height: "22px" }}
                        src={item.image || ""}
                        alt={item.name || ""}
                      />
                    }
                  </div>

                  <div>
                    {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                  </div>
                </div>
              );
            })
          ) : (
            <p>No Access</p>
          )}
        </div>
      </div>
      <div
        style={{
          padding: "18px 74px 18px 24px",
          color: "#FFF",
          fontSize: "14px",
          fontFamily: "Gilroy-Medium",
        }}
      ></div>
      {/* <button
        style={{ margin: " 0px auto 10px 100px" }}
        onClick={logoutFunction}
        className="logout-button"
      >
        <Logout style={{ maxWidth: "20px", maxHeight: "15px" }}></Logout>
        Logout
      </button> */}
    </div>
  );
};

export default SideBar;
